// @flow


import React from 'react';
import { Dots } from 'react-activity';
import styled from 'styled-components';
import SkippableChallenge from './SkippableChallenge';
import { sendWebKitMessage } from '../../../lib/kwizzad-ji.jsx';


const StyledContainer = styled.div`
    .absContainer, .loading {
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: radial-gradient(circle at center, #636363, black 100%);
    }

    .loading {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;


class ExternalNativeChallenge extends SkippableChallenge {
    render() {
        return (
            <StyledContainer className={`challengeContainer ${this.props.className || ''}`}>
                {this.state.loading ? <div className="loading"><Dots size={30} /></div> : null}
                {this.skipButton()}
            </StyledContainer>
        );
    }

    componentDidMount() {
        super.componentDidMount();
        const challengeJSON = JSON.stringify(this.props.challenge);

        if (typeof window.KwizzAdJI !== 'undefined') {
            if (typeof window.KwizzAdJI.nativeChallenge === 'function') {
                window.KwizzAdJI.nativeChallenge(challengeJSON);
            }
        }
        sendWebKitMessage('nativeChallenge', challengeJSON);
    }
}


export default ExternalNativeChallenge;



// WEBPACK FOOTER //
// ./src/campaign/challenges/external-sdks/ExternalNativeChallenge.jsx